import * as React from 'react';
import classNames from 'classnames';

import { Typography } from '@canvas-logic/clp-shared-ui';

import ThemeDefinition from '../../ui-kit/domain/ThemeDefinition';

import styles from './SelectorLabel.module.css';

interface IProps {
  component: React.ElementType;
  className?: string;
  title?: string;
  icon?: string;
  iconAltText?: string;
  description?: string;
}

const SelectorLabel: React.FC<IProps> = ({
  className,
  component: Component = '',
  title,
  icon,
  iconAltText,
  description,
}) => {
  return (
    <Component className={classNames(styles.root, className)}>
      {icon && <img className={ThemeDefinition.selectorLabel.icon} src={icon} alt={iconAltText} />}
      {title && (
        <Typography variant="heading6" component="span" className={ThemeDefinition.typography.title}>
          {title}
        </Typography>
      )}
      {description && (
        <Typography
          variant="paragraph-sm"
          component="span"
          color="description"
          className={ThemeDefinition.typography.description}
        >
          {description}
        </Typography>
      )}
    </Component>
  );
};

export default SelectorLabel;
